import { LaneLine, Vector2 } from "../models";

declare module "../models/LaneLine.gen" {
    interface LaneLine {
        clampPointIfClosing(point: Vector2, threshold: number): Vector2;
        isComplete(): boolean;
        isExplicitlyCompleted?: boolean;
    }
}

LaneLine.prototype.isComplete = function () {
    const numPoints = this.points?.length ?? 0;
    // Complete when it has 2+ points AND either was just finished by the user (middle-click,
    // Enter, double-click) or is a persisted lane line. isExplicitlyCompleted is a client-only
    // augmentation that is not on the wire model or the server, so it never survives a save —
    // without the id check every saved lane line would report incomplete forever, and the
    // "unstarted shape" cleanup would drop it mid-edit.
    return (this.isExplicitlyCompleted === true || isValidGuid(this.id)) && numPoints >= 2;
}

LaneLine.prototype.clampPointIfClosing = function (point: Vector2, threshold: number) {
    return point; 
}

function isValidGuid(guid: string | undefined): boolean {
    const emptyGuid = "00000000-0000-0000-0000-000000000000";
    const guidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

    return !!guid && guidRegex.test(guid) && guid !== emptyGuid;
}